module.exports = __webpack_public_path__ + "static/img/report_img_xxxmyjya.68d8f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_xxxmyjya.png
// module id = UwsC
// module chunks = 21